enum TipoTabelaProcedimentoEnum {
  Tuss = 'Tuss',
  Sigtap = 'SIGTAP',
  SigtapAmbulatorial = 'SIGTAPAMBULATORIAL',
}

export default TipoTabelaProcedimentoEnum
